import { MULTI_JOURNEY_KEY, SEGMENT_KEY, JOURNEY_KEY } from 'constants/booking';
import { getInfantPassengersFromDetails } from 'utils/getInfantPassengersFromDetails';

export const isOnlyCancelationBooking = (canceledLegs, creationLegs) => canceledLegs.length > 0 && creationLegs.length === 0;

export const findJourneyAndSegmentFromDetails = (additionalDetails) =>
  additionalDetails?.filter((ad) => ad.key.includes(SEGMENT_KEY) && ad.value.includes(JOURNEY_KEY)) ?? [];

export const isBookingMultiJourney = (booking) =>
  !!booking?.additionalDetails?.find((ad) => ad.key === MULTI_JOURNEY_KEY && ad.value === 'true');

export const buildCancelationLegsPerJourney = (booking) => {
  const journeys = findJourneyAndSegmentFromDetails(booking?.additionalDetails);
  let multiJourneyLegs = [];

  journeys.map((journey) => {
    const journeyId = journey.value.split('_')[1];
    const multiJourney = multiJourneyLegs.find((multiLeg) => multiLeg.journeyId === journeyId);

    if (!multiJourney) {
      multiJourneyLegs.push({
        journeyId: journeyId,
        legs: []
      });
    }

    return multiJourneyLegs
      ?.find((multiLeg) => multiLeg.journeyId === journeyId)
      ?.legs?.push(...booking.pendingCancellationLegs.filter((leg) => leg.id === journey.key));
  });

  return multiJourneyLegs;
};

export const getMultiJourneyLegs = (booking) => {
  const cancelationLegsPerJourney = buildCancelationLegsPerJourney(booking);
  return cancelationLegsPerJourney?.filter((l) => Boolean(l.legs.length));
};

export const passengersPendingCancellationHaveInfants = ({ additionalDetails = [], pendingCancellationLegs = [] }) =>
  getInfantPassengersFromDetails({ additionalDetails: additionalDetails }).some(({ passengerRef }) =>
    pendingCancellationLegs.some(({ products = [], bookingItems = [] }) =>
      [...products, ...bookingItems].some(({ passengerId }) => passengerId === passengerRef)
    )
  );
